export type StemName =
  | 'voice'
  | 'music'
  | 'effects'
  | 'other'
  | 'drums'
  | 'bass';

export interface StemDef {
  name: StemName;
  title: string;
  colorVar: string;
  filename: string;
}

export interface ModelDef {
  id: string;
  label: string;
  stems: StemDef[];
}

// Stem order matters: draw Z-order runs from index 0 (backmost) to the last
// (frontmost), matching SoundApp's `blendOver` loop.

export const CINEMATIC_MODEL: ModelDef = {
  id: 'cinematic',
  label: 'Cinematic — 4 Stems',
  stems: [
    { name: 'music', title: 'Music', colorVar: '--sa-stem-music', filename: 'music.mp3' },
    { name: 'effects', title: 'Effects', colorVar: '--sa-stem-effects', filename: 'effects.mp3' },
    { name: 'other', title: 'Other', colorVar: '--sa-stem-other', filename: 'other.mp3' },
    { name: 'voice', title: 'Voice', colorVar: '--sa-stem-voice', filename: 'voice.mp3' },
  ],
};

export const MUSIC_MODEL: ModelDef = {
  id: 'music',
  label: 'Music — 4 Stems',
  stems: [
    { name: 'drums', title: 'Drums', colorVar: '--sa-stem-drums', filename: 'drums.mp3' },
    { name: 'bass', title: 'Bass', colorVar: '--sa-stem-bass', filename: 'bass.mp3' },
    { name: 'other', title: 'Other', colorVar: '--sa-stem-other', filename: 'other.mp3' },
    { name: 'voice', title: 'Voice', colorVar: '--sa-stem-voice', filename: 'voice.mp3' },
  ],
};

export const VOICE_MODEL: ModelDef = {
  id: 'voice',
  label: 'Voice — 2 Stems',
  stems: [
    { name: 'other', title: 'Other', colorVar: '--sa-stem-other', filename: 'other.mp3' },
    { name: 'voice', title: 'Voice', colorVar: '--sa-stem-voice-bright', filename: 'voice.mp3' },
  ],
};

export const MODELS: Record<string, ModelDef> = {
  cinematic: CINEMATIC_MODEL,
  music: MUSIC_MODEL,
  voice: VOICE_MODEL,
};

export function getModel(id: string): ModelDef {
  const model = MODELS[id];
  if (!model) {
    throw new Error(`Unknown model: ${id}`);
  }
  return model;
}
